import {
  CardContainer,
  ImageContainer,
  TextContainer,
  Image,
  TitleContainer,
  Title,
  SectionOneItemNumber,
  SubTitle,
} from './styled'
import noImg from 'assets/images/no-image.png'

interface IProps {
  image: string
  title: string
  testData: string
  params?: any
  disabled?: boolean
  is360?: boolean
}

function TestCard(props: IProps) {
  const { image, title, testData, disabled } = props

  const disabledColor = '#C2C2C2'

  return (
    <CardContainer>
      <ImageContainer style={{ background: disabled ? disabledColor : '#ffffff' }}>
        {image ? <Image disabled={disabled} src={image} /> : <Image disabled={disabled} src={noImg} />}
      </ImageContainer>
      <TextContainer style={{ background: disabled ? disabledColor : '#FBFBFB' }}>
        <TitleContainer>
          <Title style={{ color: disabled ? 'gray' : 'black' }}>{title || 'Inserte titulo'}</Title>
        </TitleContainer>
        <SectionOneItemNumber>{testData}</SectionOneItemNumber>
        <SubTitle>Aplicadas</SubTitle>
      </TextContainer>
    </CardContainer>
  )
}

export default TestCard
